@import '~@s-ui/theme/lib/settings-compat-v7/index';
@import '~@s-ui/theme/lib/index';
@import '~@adv-mt/mt-theme/lib/motor';

@import '~@adv-mt/mt-layout-basic/lib/index';

@import '~@adv-mt/mt-panel-basic/lib/index';
@import '~@adv-mt/mt-title-basic/lib/index';
@import '~@s-ui/react-molecule-avatar/lib/index';
@import '~@s-ui/react-molecule-modal/lib/index';
@import '~@adv-mt/mt-form-consent/lib/index';
@import '~@adv-mt/mt-modal-basic-content/lib/index';
@import '~@adv-mt/mt-newsletter-subscription/lib/index';

@import '../components/UserProfileInfo/styles.scss';

.mt-UserProfile {
  position: relative;

  &-info {
    padding: $p-m;

    &Title {
      margin-bottom: $m-xl;
    }

    &Avatar {
      display: flex;
      flex-direction: row;
      gap: $p-xl;
      margin-bottom: $m-xl;
    }

    &Button {
      margin-top: $m-xl;
    }
  }

  &-panel {
    padding: $p-m;

    &Section {
      margin-top: $m-xl;
      padding-bottom: $p-xl;
      border-bottom: 1px solid $c-gray-light-1;

      &:last-child {
        border-bottom: none;
      }

      &Consents {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        gap: $p-xxl;
        margin-top: $m-l;

        @include media-breakpoint-up(m) {
          grid-template-columns: repeat(2, 1fr);
        }

        &Inner {
          display: grid;
          gap: $g-l;
        }
      }

      &PrivacyActions {
        margin-top: $m-l;
      }
    }
  }

  &-notificationWrapper {
    bottom: 0;
    left: 0;
    padding: $p-l;
    position: fixed;
    right: 0;
    z-index: $z-notification;
  }

  &-notificationText {
    margin: 0;
  }

  &-consentLink {
    &Title {
      font-weight: $fw-semi-bold;
    }

    &Anchor {
      color: $c-primary;
      text-decoration: underline;
    }
  }

  &-modalContentText {
    margin-bottom: 0;
  }
}
